// extracted by mini-css-extract-plugin
export default {"mainBtn":"MainBtn_mainBtn__668Fb","mainBtn_negative":"MainBtn_mainBtn_negative__74eDZ"};